<template>
  <div name="fade" class="question-item">
    <div class="exercise-detail__list question-item__head">
      <div class="item position-rel content-1">
        <div class="icon-back-ex" v-if="bookId" @click="hanldeBackTime">
          <b><i class="icon-back-1 primary-color"></i> </b>
        </div>
        <b
          class="
            item__title
            primary-color
            font-size-16
            text-center
            display-block
          "
          style="margin-bottom: 10px"
          v-if="dataSource && dataSource.title"
        >
          {{ dataSource.title }}
        </b>
        <div
          class="
            question-content
            primary-color-txt
            font-size-16
            display-table
            full-width
          "
          v-if="dataSource && dataSource.content"
          v-html="dataSource.content"
        ></div>
        <div
          class="question-item__img text-center margin-center"
          v-if="dataSource.imageUrl"
          :style="`width: ${dataSource.imageWidth}px; max-height: ${dataSource.imageHeight}px`"
          :class="`size-${dataSource.imageWidth}-${dataSource.imageHeight}`"
        >
          <img
            :src="`${urlQuestionImg}/${dataSource.imageUrl}`"
            alt="Ảnh câu hỏi"
          />
        </div>
      </div>
    </div>
    <div
      v-if="dataSource && dataSource.type"
      class="item__answer"
      :class="`question--${dataSource.type} question--${dataSource.type}--${
        dataSource.layoutId ? dataSource.layoutId : '1'
      }`"
    >
      <div
        class="question-head-type-true-false"
        v-if="
          dataSource &&
          dataSource.type === types.TYPE_TRUE_FALSE_NO &&
          dataSource.layoutId === 2
        "
      >
        <div class="choice-radio display-flex-center justify-content-end">
          <label>Đúng</label>
          <label>Sai</label>
        </div>
      </div>
      <div
        class="question-body row"
        :class="{ row: dataSource.type === types.TYPE_DRAW_SHAPE_ANSWER }"
      >
        <div
          v-show="dataSource.type !== types.TYPE_MATH_COL"
          v-for="(item, index) of answersDisplay"
          class="answer"
          :class="{
            'col-lg-3 col-md-6 col-12':
              dataSource.type === types.TYPE_DRAW_SHAPE_ANSWER,
          }"
          :key="index"
        >
          <div
            class="answer__img__sentence text-center margin-center"
            v-if="item.imageUrl"
            :style="`width: ${dataSource.imageWidth}px; max-height: ${dataSource.imageHeight}px`"
            :class="`size-${dataSource.imageWidth}-${dataSource.imageHeight}`"
          >
            <img
              :src="`${urlQuestionImg}/${item.imageUrl}`"
              alt="Ảnh câu hỏi"
              class="answer__img"
            />
          </div>
          <PreviewAnswerItem
            v-if="item.is_deleted !== 1 && !item.position"
            :type="dataSource.type"
            :dataSource="item"
            :nameField="`answer_${dataSource.orderNo}_${location}`"
            :location="index"
            :parent="dataSource"
            :isDontShowResultSaved="isDontShowResultSaved"
            :statusCorrect="
              !isQuestionMissingAnswer &&
              ((!item.err &&
                item.correct &&
                correctStatus &&
                correctStatus === 'success') ||
                (dataSource.isWorked &&
                  !item.isError &&
                  !item.err &&
                  item.correct) ||
                (item.correct &&
                  ((dataSource && dataSource.isNoAnswer) ||
                    (questionsData && questionsData.isNoAnswer)) &&
                  dataSource.type === types.TYPE_RADIO))
                ? 'success'
                : item.err || (dataSource.isWorked && item.isError)
                ? 'err'
                : ''
            "
            @changeAnswer="setValueCorrect"
          />
          <!-- :statusCorrect="(!item.err && item.correct && correctStatus && correctStatus === 'success' && !isQuestionMissingAnswer) || (dataSource.isWorked && !item.isError && ((item.content && item.content === item.correct) || (!item.content && item.answerContent) )) ? 'success' : (item.err || (dataSource.isWorked && item.isError) ? 'err' : '')" -->
        </div>
      </div>
      <div
        v-if="dataSource.type === types.TYPE_MATH_COL"
        class="
          answers-math-col
          display-flex
          justify-content-between
          position-rel
        "
        :class="`answers-math-col-${dataSource.layoutId}`"
      >
        <div
          class="math-left match-left-box"
          v-if="arrMathColLeft && arrMathColLeft.length > 0"
        >
          <template v-for="(item, index) of arrMathColLeft">
            <div
              v-if="item && (item.code || item.content || item.imageUrl)"
              :key="index"
              class="item"
              :id="`match_left_${index}`"
              :class="{
                activity:
                  classNameMatchLeftActivity === `${item.position}_${index}`,
                'border-0':
                  !item || (!item.code && !item.content && !item.imageUrl),
              }"
              @click="setCorrectMatch('left', index, item, dataSource.layoutId)"
            >
              <PreviewAnswerItem
                :type="dataSource.type"
                :dataSource="item"
                :nameField="`answer_${dataSource.orderNo}_${location}`"
                :location="index"
                :parent="dataSource"
                :isDontShowResultSaved="isDontShowResultSaved"
                :class="{
                  'answer-err':
                    !isDontShowResultSaved &&
                    ((item.err && dataSource.statusWorked) ||
                      (item.isError && dataSource.isWorked)),
                  'answer-true':
                    !isDontShowResultSaved &&
                    ((!item.err && dataSource.statusWorked && !item.isError) ||
                      (!item.isError &&
                        dataSource.isWorked &&
                        !dataSource.isNoAnswer)),
                }"
              />
              <svg
                v-show="item.line"
                :height="item.line.height"
                :width="item.line.width"
              >
                <line
                  :x1="item.line.x1"
                  :y1="item.line.y1"
                  :x2="item.line.x2"
                  :y2="item.line.y2"
                  style="stroke: #0f3dba; stroke-width: 2"
                />
                Sorry, your browser does not support inline SVG.
              </svg>
            </div>
          </template>
        </div>
        <div class="math-right" v-if="arrMathColRight">
          <template v-for="(item, index) of arrMathColRight">
            <div
              v-if="item && (item.code || item.content || item.imageUrl)"
              :key="index"
              class="item position-rel"
              :class="{
                activity:
                  classNameMatchRightActivity === `${item.position}_${index}`,
                'border-0':
                  !item || (!item.code && !item.content && !item.imageUrl),
              }"
              :id="`match_right_${index}`"
              @click="
                setCorrectMatch('right', index, item, dataSource.layoutId)
              "
            >
              <PreviewAnswerItem
                :type="dataSource.type"
                :dataSource="item"
                :nameField="`answer_${dataSource.orderNo}_${location}`"
                :location="index"
                :parent="dataSource"
                :isDontShowResultSaved="isDontShowResultSaved"
                :class="{
                  'answer-err':
                    (item.err && dataSource.statusWorked) ||
                    (item.isError && dataSource.isWorked),
                  'answer-true':
                    (!item.err && dataSource.statusWorked && !item.isError) ||
                    (!item.isError &&
                      dataSource.isWorked &&
                      !dataSource.isNoAnswer),
                }"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <div
      class="question-missing-answer color-err"
      v-if="isQuestionMissingAnswer && !isListQuestion"
    >
      {{ textErr }}
    </div>
  </div>
</template>

<script>
import * as types from "./_store/constants";
import { LOCAL_SAVE_QUESTIONS_WORKED } from "@/modules/exercises/_store/constants";
import { mapState, mapActions } from "vuex";
import {
  setValueCorrectHelper,
  getCorrectGroupChoosed,
  setCorrectGroupChoosed,
  setContentQuestionFillSelect,
  getContentQuestionFillSelect,
  resetContentQuestionFillSelect,
} from "./_store/helpers";
import { CHANGE_TXT_ANSWER } from "@/store/common/constants";
import { APP_CONFIG } from "@/utils/constants";
import mixinsQuestionPreview from "./_store/mixinsQuestionPreview";
import { stripHtml } from "@/helpers/functions";

CKEDITOR.plugins.addExternal("ckeditor_wiris", "/libs/mathtype/plugin.js");

export default {
  name: "PreviewQuestion",
  mixins: [mixinsQuestionPreview],
  props: {
    dataSource: Object,
    location: Number,
    preview: Boolean,
    parentIndex: Number,
    isQuestionChild: Boolean,
    questionsData: Object,
    questionSetVal: Object,
    isDontShowResultSaved: Boolean,
    isListQuestion: Boolean,
  },
  components: {
    PreviewAnswerItem: () => import("./PreviewAnswerItem.vue"),
  },
  data() {
    return {
      types,
      loading: false,
      textErr: "",
      valCorrect: [],
      valCorrectGroup: [],
      checkFillType: [],
      answersDisplay: [],
      arrMathColLeft: [],
      arrMathColRight: [],
      valMatchLeft: [],
      valMatchRight: [],
      arrResultCorrect: [],
      classNameMatchLeftActivity: "",
      classNameMatchRightActivity: "",
      isQuestionMissingAnswer: false,
      correctStatus: "",
      valueHTMLAnswerTypEessay: "",
      urlQuestionImg: APP_CONFIG.urlQuestionImg,
    };
  },
  computed: {
    ...mapState(types.STORE_KEY, [
      "valVituralKeyboard",
      "valHandleSetQuestionValue",
      "questionGroupIsCheckAnswer",
      "question",
      "questionDataCheckAnswer",
      "questionList4CheckAnswer",
    ]),
    ...mapState("common", ["actionCheckQuestion", "draw_shape_data"]),
    bookId() {
      return this.$route.params.bookId;
    },
  },
  watch: {
    $route: "refeshData",
    dataSource(newVal) {
      this.formatDisplayData(true);
      // this.formatDataMathCol();
    },
    draw_shape_data(newVal, oldVal) {
      if (
        newVal &&
        newVal.type === "answer" &&
        newVal.data &&
        newVal.position > -1 &&
        newVal.questionParent &&
        this.dataSource.questionId === newVal.questionParent.questionId
      ) {
        // && this.position === newVal.position
        if (newVal.questionParent.type === types.TYPE_GROUP) {
          let indexInQuestionGroup =
            this.questionsData.listQuestionChild.findIndex(
              (group) => group.questionId === newVal.questionParent.questionId
            );
        } else {
          this.dataSource.answers[newVal.position].content = newVal.data;
          this.dataSource.answers[newVal.position].answerContent = newVal.data;
          let indexCorrect =
            this.valCorrect.findIndex(
              (ans) => ans.position === newVal.position
            ) || -1;
          let valueAnswer = { position: newVal.position, value: newVal.data };
          if (indexCorrect > -1) {
            this.valCorrect[indexCorrect] = valueAnswer;
          } else {
            this.valCorrect.push(valueAnswer);
          }
        }
        // console.log('done: ', newVal)
        this.$emit("writedAnswer", {
          answers: this.valCorrect,
          question: this.dataSource,
        });
      }
    },
    actionCheckQuestion(newVal) {
      newVal && this.checkCorrectAnswer();
    },
  },
  created() {
    this.$bus.on(
      `${CHANGE_TXT_ANSWER}_${this.dataSource.questionId}`,
      this.handleChangeTxtAnswer
    );
  },
  mounted() {
    this.refeshData();
    this.formatDisplayData(true);
    // console.log('this.dataSource', this.dataSource.questionId);
    this.actionSetQuestionId(this.dataSource.questionId);
    // this.getAnswerChoosedForQuestion();
    // this.formatDataMathCol();
  },
  destroyed() {
    setCorrectGroupChoosed([]);
    this.$bus.off(
      `${CHANGE_TXT_ANSWER}__${this.dataSource.questionId}`,
      this.handleChangeTxtAnswer
    );
  },
  methods: {
    ...mapActions("common", ["setActionCheckQuestion", "actionSetQuestionId"]),
    ...mapActions(types.STORE_KEY, [
      "validateQuestion",
      "setQuestion",
      "setQuestions",
      "setCorrectQuestionGroup",
    ]),

    hanldeBackTime() {
      this.$router.push({
        name: "exerciseDetail",
        params: { id: this.bookId },
      });
    },
    refeshData() {
      this.correctStatus = "";
      this.valCorrect = [];
      this.valCorrectGroup = [];
      this.arrResultCorrect = [];
      this.isQuestionMissingAnswer = false;
      this.valueHTMLAnswerTypEessay = "";
      this.checkCorrectQuestionWorked();
    },

    async formatDisplayData(isMounted = false) {
      let typeQuestion = this.dataSource.type;
      this.refeshData();

      this.answersDisplay.length = 0;
      if (
        typeQuestion === types.TYPE_SELECT ||
        typeQuestion === types.TYPE_FILL_BLANK
      ) {
        this.dataSource.answers &&
          this.dataSource.answers.length > 0 &&
          this.dataSource.answers.map((ans) => {
            !ans.position && this.answersDisplay.push(ans);
          });
      } else if (this.dataSource.answers) {
        // if(this.dataSource.answers) {
        this.answersDisplay = [...this.dataSource.answers];
        // }
      }
      await this.setQuestion({ ...this.dataSource });
      this.formatDataMathCol(isMounted);
    },

    async formatDataMathCol(isMounted = false) {
      let self = this;
      if (
        self.dataSource.type === types.TYPE_MATH_COL &&
        self.dataSource.answers
      ) {
        let dataLeft = [];
        let dataRight = [];
        await self.dataSource.answers.map((ans) => {
          if (ans.is_deleted !== 1) {
            let positionItem = ans.position.split("_");
            /*
             * positionItem[0]: left/right column
             * positionItem[1]: index of array answers
             */
            if (!ans.line) {
              ans["line"] = { width: 0, height: 0, x1: 0, y1: 0, x2: 0, y2: 0 };
            }
            if (positionItem[0] === "left") {
              dataLeft[positionItem[1]] = ans;
              const { answerId, answerContent } = ans;
              self.dataSource["userPractice"] = !self.dataSource["userPractice"]
                ? [{ answerId, answerContent }]
                : [
                    ...self.dataSource["userPractice"],
                    { answerId, answerContent },
                  ];
            } else {
              dataRight[positionItem[1]] = ans;
            }
          }
        });
        self.arrMathColLeft = [...dataLeft];
        self.arrMathColRight = [...dataRight];

        !self.dataSource.statusWorked && this.setLineMatchCol();
        // !self.dataSource.isWorked && this.setLineMatchCol()
        // Settimeout because render DOM for col left/right
        isMounted &&
          self.dataSource.isWorked &&
          setTimeout(() => {
            self.drawLineSaved();
            // self.drawLineMatchCol(self.dataSource.layoutId)
          }, 200);
        // console.log('Data question: ', dataLeft, dataRight)
      }
    },

    setLineMatchCol() {
      if (
        this.dataSource.type === types.TYPE_MATH_COL &&
        this.dataSource.answers
      ) {
        let itemBoxMatch = document.querySelector(".answers-math-col");
        let colLeft = document.querySelector(".match-left-box");
        let widthBox = itemBoxMatch ? itemBoxMatch.offsetWidth : 0;
        let heightBox = colLeft ? colLeft.offsetHeight : 0;
        let widthMatchBox = colLeft ? colLeft.offsetWidth : 0;
        this.arrMathColLeft &&
          this.arrMathColLeft.map((match, index) => {
            match.line = {
              width: widthBox,
              height: heightBox,
              x1: this.dataSource.isWorked ? widthMatchBox : 0,
              y1: 0,
              x2: 0,
              y2: 0,
            };
          });
      }
    },

    drawLineSaved() {
      let self = this;
      self.dataSource.userPractice.map((prac) => {
        let indexAnswerColLeft = self.arrMathColLeft.findIndex(
          (col) => col.answerId === prac.answerId
        );
        let indexAnswerColRight = self.arrMathColRight.findIndex(
          (col) => col.code === prac.answerContent
        );
        // Set colright choosed
        self.valMatchRight = [indexAnswerColRight, prac.answerContent];
        self.setCorrectMatch(
          "left",
          indexAnswerColLeft,
          self.arrMathColLeft[indexAnswerColLeft],
          self.dataSource.layoutId
        );
      });
    },

    setCorrectMatch(col, index, data, layout) {
      let self = this;
      if (col === "left") {
        self.classNameMatchLeftActivity = `${data.position}_${index}`;
        self.valMatchLeft = [index, data.code];
        if (self.valMatchRight && self.valMatchRight.length > 0) {
          self.removeHasLineMatch();
          self.drawLineMatchCol(layout);
        }
      } else {
        self.classNameMatchRightActivity = `${data.position}_${index}`;
        self.valMatchRight = [index, data.code];
        if (self.valMatchLeft.length > 0) {
          self.removeHasLineMatch();
          self.drawLineMatchCol(layout);
        }
      }
    },

    drawLineMatchCol(layout = 1) {
      let self = this;
      self.setValueCorrectMatchType(
        self.valMatchLeft[1],
        self.valMatchRight[1]
      );

      let result = [...self.arrMathColLeft];
      if (self.valMatchRight[0] === -1) {
        return;
      }
      let offsetIndexLeft = document.getElementById(
        `match_right_${self.valMatchRight[0]}`
      ).offsetLeft;

      // console.log('Draw layout: ', layout)
      if (layout === 2) {
        let colQuestion = document.querySelector(".answers-math-col");
        let heightCol1 = document.querySelector(".match-left-box").offsetHeight;
        let widthItem = document.querySelector(
          ".match-left-box .item"
        ).offsetWidth;
        let offsetItemLeftX = document.getElementById(
          `match_left_${self.valMatchLeft[0]}`
        ).offsetLeft;
        let offsetCol2ToTop = document.querySelector(".math-right").offsetTop;
        result[self.valMatchLeft[0]].line.height = colQuestion.offsetHeight;
        result[self.valMatchLeft[0]].line.x1 = offsetItemLeftX + widthItem / 2;
        result[self.valMatchLeft[0]].line.y1 = heightCol1;
        result[self.valMatchLeft[0]].line.x2 = offsetIndexLeft + widthItem / 2;
        result[self.valMatchLeft[0]].line.y2 = offsetCol2ToTop;
      } else {
        let offsetItemRightTop = document.getElementById(
          `match_right_${self.valMatchRight[0]}`
        ).offsetTop;
        let heightItemRightTop = document.getElementById(
          `match_right_${self.valMatchRight[0]}`
        ).offsetHeight;
        let offsetItemLeftTop = document.getElementById(
          `match_left_${self.valMatchLeft[0]}`
        ).offsetTop;
        let heightItemLeftTop = document.getElementById(
          `match_left_${self.valMatchLeft[0]}`
        ).offsetHeight;
        let colLeft = document.querySelector(".match-left-box");
        result[self.valMatchLeft[0]].line.height = colLeft.offsetHeight;
        result[self.valMatchLeft[0]].line.x1 = colLeft.offsetWidth;
        result[self.valMatchLeft[0]].line.y1 =
          offsetItemLeftTop + heightItemLeftTop / 2;
        result[self.valMatchLeft[0]].line.x2 = offsetIndexLeft;
        result[self.valMatchLeft[0]].line.y2 =
          offsetItemRightTop + heightItemRightTop / 2;
      }
      self.arrMathColLeft = [...result];

      self.valMatchLeft.length = 0;
      self.valMatchRight.length = 0;
      self.classNameMatchLeftActivity = "";
      self.classNameMatchRightActivity = "";
    },

    removeHasLineMatch() {
      let self = this;
      let indexMatchInvalCorrect = self.valCorrect.findIndex(
        (val) => val.value === self.valMatchRight[1]
      );
      if (indexMatchInvalCorrect > -1) {
        let indexMatchInArrLeft = self.arrMathColLeft.findIndex(
          (data) =>
            data.position === self.valCorrect[indexMatchInvalCorrect].parent
        );
        if (indexMatchInArrLeft > -1) {
          self.arrMathColLeft[indexMatchInArrLeft].line = {
            ...self.arrMathColLeft[indexMatchInArrLeft].line,
            height: 0,
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 0,
          };
          self.valCorrect.splice(indexMatchInvalCorrect, 1);
        }
      }
    },

    setValueCorrectMatchType(codeLeft, codeRight) {
      let indexAnswers = this.dataSource.answers.findIndex(
        (ans) => ans.code === codeLeft
      );
      let parentAnswer = this.dataSource.answers[indexAnswers].position;
      let indexCorrect = this.valCorrect.findIndex(
        (ans) => ans.position === indexAnswers
      );
      // Line for save in answer question
      // let lineAnswer = this.dataSource.answers[indexAnswers].line;
      let valueAnswer = {
        position: indexAnswers,
        value: codeRight,
        parent: parentAnswer,
      };

      if (indexCorrect > -1) {
        this.valCorrect[indexCorrect] = valueAnswer;
      } else {
        this.valCorrect.push(valueAnswer);
      }
      // console.log('draw', this.valCorrect, this.arrMathColLeft);
      this.$emit("writedAnswer", {
        answers: this.valCorrect,
        question: this.dataSource,
      });
      // this.setValueCorrect(valueAnswer);
    },

    /**
     * @method Set correct val checked
     **/
    checkCorrectQuestionWorked() {
      let self = this;
      let typeQuestion = self.questionsData
        ? self.questionsData.type
        : self.dataSource.type;
      let questionCurr = self.questionsData
        ? self.questionsData
        : self.dataSource;
      if (questionCurr.statusWorked || questionCurr.isWorked) {
        if (this.questionsData && typeQuestion === types.TYPE_GROUP) {
          let corrected = [];
          let dataCorrect = [];
          questionCurr.listQuestionChild.map((que, index) => {
            if (que) {
              dataCorrect = self.setCorrectAnswerQuestionSingle(que, que.type);
              let data = { questionId: que.questionId, correct: dataCorrect };
              corrected.push(data);
              setCorrectGroupChoosed(corrected);
            }
          });
        } else {
          self.valCorrect = self.setCorrectAnswerQuestionSingle(
            questionCurr,
            typeQuestion
          );
        }
      }
    },

    setCorrectAnswerQuestionSingle(questionCurr, typeQuestion) {
      let dataResult = [];
      if (
        typeQuestion === types.TYPE_SELECT ||
        typeQuestion === types.TYPE_FILL_BLANK
      ) {
        let answersParent = questionCurr.answers.filter((ans) => !ans.position);
        // console.log('have ques: ', answersParent)
        answersParent &&
          answersParent.length > 0 &&
          answersParent.map((ans, index) => {
            if (ans.validateVal && ans.validateVal.length > 0) {
              ans.validateVal.map((val, pos) => {
                let dataVal = {
                  position: index,
                  value: val,
                  select_index: pos,
                  parent: `${index}_${pos}`,
                };
                dataResult.push(dataVal);
              });
            }
          });
      } else {
        questionCurr.answers.map((ans, index) => {
          if (ans.answerContent) {
            let dataVal = { position: index, value: ans.answerContent };
            if (typeQuestion === types.TYPE_MATH_COL) {
              dataVal["parent"] = ans.position;
            }
            dataResult.push(dataVal);
          }
        });
      }

      // console.log('Set question val single: ', dataResult)
      return dataResult;
    },

    getAnswerChoosedForQuestion() {
      let dataHandle =
        this.questionsData && this.questionsData.type === types.TYPE_GROUP
          ? this.questionsData
          : this.question;
      if (dataHandle.dataChoosed && dataHandle.dataChoosed.length > 0) {
        dataHandle.dataChoosed.map((val) => {
          this.setValueCorrect(val, true);
        });
      }
    },

    setValueCorrect(data, isLoadLocal) {
      // console.log('setval data: ', data, this.questionsData, this.question);

      if (
        this.question &&
        this.question.type === types.TYPE_RADIO &&
        this.question.answers
      ) {
        this.question.answers.map((ans, index) => {
          if (index !== data.position) ans.answerContent = null;
        });
      }
      let valCorrectCurr = this.valCorrect;

      let isQuestionGroup =
        this.questionsData && this.questionsData.type === types.TYPE_GROUP
          ? true
          : false;
      if (isQuestionGroup) {
        let correcGroup = getCorrectGroupChoosed();
        let indexQuestionGroup = correcGroup.findIndex(
          (cor) => cor.questionId === data.questionId
        );

        // console.log('Set val: ',  correcGroup, indexQuestionGroup);

        // console.log('Set value group: ', correcGroup, indexQuestionGroup )
        if (indexQuestionGroup > -1) {
          valCorrectCurr = correcGroup[indexQuestionGroup].correct;
          // console.log('Val have', valCorrectCurr, correcGroup);
        }

        // remove answer not choose
        this.questionsData &&
          this.questionsData.listQuestionChild.map((ques) => {
            let indexQuesCorrect = correcGroup.findIndex(
              (cor) => cor.questionId === ques.questionId
            );
            if (indexQuesCorrect > -1) {
              ques.answers.map((ans, pos) => {
                if (
                  correcGroup[indexQuesCorrect].correct.findIndex(
                    (cor) => cor.position === pos
                  ) === -1 &&
                  ans.answerContent
                ) {
                  delete ans.answerContent;
                }
              });
            }
          });
      }

      // saveAnswerChoose
      !isLoadLocal && this.saveAnswerChoosed(data);

      this.valCorrect = setValueCorrectHelper(
        data,
        valCorrectCurr,
        isQuestionGroup
      );
      // await setValueCorrectHelper(data, this.valCorrect, isQuestionGroup);
      // console.log('Set value group: ', this.valCorrect )
      // console.log('Check val preview: ', this.valCorrect, data, isQuestionGroup)
      this.$emit("writedAnswer", {
        answers: this.valCorrect,
        question: this.dataSource,
      });
    },

    saveAnswerChoosed(data) {
      if (this.questionsData && this.questionsData.type === types.TYPE_GROUP) {
        if (!this.questionsData["dataChoosed"]) {
          this.questionsData["dataChoosed"] = [data];
        } else {
          let indexDataChoose = this.questionsData["dataChoosed"].findIndex(
            (choose) =>
              choose.answerId === data.answerId &&
              choose.position === data.position
          );
          if (data.type === types.TYPE_FILL_BLANK) {
            // console.log('Type fill blank');
            indexDataChoose = this.questionsData["dataChoosed"].findIndex(
              (choose) =>
                choose.answerId === data.answerId &&
                choose.position === data.position &&
                choose.fill_index === data.fill_index
            );
          }
          // console.log('Index for answer choose: ', indexDataChoose, this.questionsData['dataChoosed']);

          if (indexDataChoose > -1) {
            this.questionsData["dataChoosed"][indexDataChoose] = data;
          } else {
            this.questionsData["dataChoosed"].push(data);
          }
        }
      } else {
        if (!this.question["dataChoosed"]) {
          this.question["dataChoosed"] = [data];
        } else {
          this.question["dataChoosed"].push(data);
        }
      }
    },

    async checkCorrectAnswer() {
      let self = this;
      // console.log('Check answer question: ', self.questionDataCheckAnswer);
      if (
        self.questionDataCheckAnswer &&
        self.questionDataCheckAnswer.isGroup
      ) {
        // console.log('Working width question group', self.questionsData);
        let indexQuestionParent = self.questionList4CheckAnswer.findIndex(
          (ques) => ques.questionId === self.questionDataCheckAnswer.parent
        );

        // questionsData is props
        let questionParentWork =
          indexQuestionParent > -1
            ? self.questionList4CheckAnswer[indexQuestionParent]
            : self.questionsData;
        questionParentWork["workedFail"] = null;
        // Get answer from helper file
        let answerChoosed = getCorrectGroupChoosed();

        // console.log('Answers group: ', answerChoosed);

        let lengthChild = questionParentWork.listQuestionChild.length;

        if (!answerChoosed || answerChoosed.length === 0) {
          self.textErr = "Bạn hãy điền đầy đủ các câu trả lời!";
          self.$emit("answerMissing", self.textErr);
          this.$emit("setCorrectAnswer", false);
          self.setActionCheckQuestion(false);
          return;
        } else this.$emit("setCorrectAnswer", true);

        // console.log('Check answer: ', answerChoosed);
        questionParentWork["isWorked"] = true;
        // Loop all question child
        questionParentWork.listQuestionChild.map((ques, index) => {
          let indexValCorect = answerChoosed.findIndex(
            (cor) => cor.questionId === ques.questionId
          );
          // console.log(index, 'AAAAAAAAA', lengthChild, answerChoosed, indexValCorect, indexValCorect);
          if (index === lengthChild - 1) {
            self.setActionCheckQuestion(false);
          }
          if (indexValCorect > -1) {
            // console.log('Index have: ', index, indexValCorect)
            questionParentWork.listQuestionChild[index] = self.checkAnswer(
              ques,
              answerChoosed[indexValCorect].correct
            );

            // console.log('Val check answer :', questionParentWork.listQuestionChild[index], self.correctStatus);
            console.log("chỗ này");
            if (self.correctStatus === "error") {
              questionParentWork["workedFail"] = "error";
              questionParentWork["isTrue"] = false;
            }
            ques["isTrue"] = self.correctStatus === "error" ? false : true;
            questionParentWork["statusWorked"] = "worked";
            questionParentWork.listQuestionChild.map((que) => {
              que["isWorked"] = true;
              que &&
                que.answers &&
                que.answers.map((ans) => {
                  if (que["isTrue"] === null) {
                    que["isTrue"] = true;
                  }
                  if (
                    ans.err ||
                    (ans.validate && ans.validate.includes(false))
                  ) {
                    questionParentWork["workedFail"] = "error";
                    if (que["isTrue"]) {
                      que["isTrue"] = false;
                    }
                  }
                });
            });

            self.saveQuestionWorked(questionParentWork);
            // if(index === lengthChild - 1) {
            self.$emit("getResultQuestion", self.arrResultCorrect);
            self.$emit("formatQuestion", null);
            // }
          }
        });
      } else if (self.questionDataCheckAnswer) {
        // check answer for question working
        let questionWork =
          self.questionList4CheckAnswer &&
          self.questionList4CheckAnswer.length > 0
            ? self.questionList4CheckAnswer[self.location]
            : self.dataSource;
        let correctChoosed =
          self.questionDataCheckAnswer &&
          self.questionDataCheckAnswer.answerChoosed
            ? self.questionDataCheckAnswer.answerChoosed
            : self.valCorrect;
        // let correctChoosed = self.isListQuestion ? self.questions[self.location].answerChoosed : self.valCorrect

        questionWork["workedFail"] = null;
        if (questionWork.type !== types.TYPE_DOWN_ANSWER) {
          self.checkAnswer(questionWork, correctChoosed);
        } else {
          questionWork.answers[0].answerContent = self.valueHTMLAnswerTypEessay;
        }
        console.log("chỗ này");
        if (!self.isQuestionMissingAnswer) {
          questionWork["workedFail"] =
            self.correctStatus === "error" ? "error" : null;
          questionWork["correctData"] = self.arrResultCorrect;
          questionWork["isTrue"] =
            self.correctStatus === "error" ? false : true;
          questionWork["isWorked"] = true;
          console.log(questionWork.isTrue, questionWork);

          if (questionWork.isTrue == true) {
            setTimeout(() => {
              document.getElementById("question_true").play();
            }, 5);
          } else if (questionWork.isTrue == false) {
            setTimeout(() => {
              document.getElementById("question_false").play();
            }, 5);
          }

          self.saveQuestionWorked(questionWork);
          if (questionWork.type !== types.TYPE_DOWN_ANSWER) {
            self.$emit("getResultQuestion", self.arrResultCorrect);
          }
          self.$emit("formatQuestion", null);
        }
      }
    },

    setStatusAnswerForQuestion() {
      let self = this;
      let result = "";
      let lengthQuestionGroup = self.questionsData.listQuestionChild.length;
      for (let i = 0; i < lengthQuestionGroup; i++) {
        let lengthAnswer =
          self.questionsData.listQuestionChild[i].answers.length;
        for (let j = 0; j < lengthAnswer; j++) {
          let ans = self.questionsData.listQuestionChild[i].answers[j];
          if (ans.err || (ans.validate && ans.validate.includes(false))) {
            result = "error";
            break;
          }
        }
        if (result === "error") {
          break;
        }
      }
      return result;
    },

    checkAnswer(question, valCorrectChoosed) {
      let self = this;
      let dataQuestion = question;
      // Variable for fixed error remove form input data answer with position
      // let dataQuestionFillBlank = question;
      let statusAnswer = true;

      let valChoosedHaveValue = valCorrectChoosed
        ? valCorrectChoosed.filter((val) => val.value)
        : [];
      let lengthChooseAnswer = valChoosedHaveValue.length;
      let lengthAnswerCorrect;
      // let typeQuestion = self.questionsData && self.questionsData.type === types.TYPE_GROUP ? types.TYPE_GROUP : dataQuestion.type;
      let typeQuestion = dataQuestion.type;
      // let isQuestionGroup = self.questionsData && self.questionsData.type === types.TYPE_GROUP ? true : false;
      self.textErr = "";
      self.correctStatus = "";
      self.isQuestionMissingAnswer = false;

      // Reset status for correct checked
      dataQuestion.answers.map((ans) => {
        ans.err && delete ans.err;
        ans.isError && delete ans.isError;
        ans.success && delete ans.success;
      });

      // console.log('First check: ', typeQuestion)
      // count length Answer correct real
      if (typeQuestion === types.TYPE_MATH_COL) {
        lengthAnswerCorrect = dataQuestion.answers.filter(
          (ans) =>
            ans.correct && ans.isDeleted !== 1 && ans.position.includes("left")
        ).length;
      } else if (
        typeQuestion === types.TYPE_FILL_BLANK ||
        typeQuestion === types.TYPE_SELECT
      ) {
        // let answersIsWrite = dataQuestion.answers.filter(ans => ans.position && ans.isDeleted !== 1 );
        // let dataAnswersAppro = [];
        // Get content from helper
        let contentFill = getContentQuestionFillSelect();

        lengthAnswerCorrect = 0;
        if (contentFill && contentFill.length > 0) {
          contentFill.map((content) => {
            if (content && content.length > 0) {
              content.map((txt) => {
                if (txt && txt.length > 0) {
                  let lengthContent = txt.length;
                  txt.map((data, index) => {
                    if (data && data !== "null" && index < lengthContent - 1) {
                      lengthAnswerCorrect += 1;
                    }
                  });
                }
              });
            }
          });
        }
      } else if (
        [
          types.TYPE_RADIO,
          types.TYPE_CHECKBOX,
          types.TYPE_X_MARK,
          types.TYPE_CIRCLE_ANSWER,
        ].includes(typeQuestion)
      ) {
        // Only has 1 answer
        lengthAnswerCorrect = 1;
      } else {
        lengthAnswerCorrect = dataQuestion.answers.filter(
          (ans) => ans.correct && ans.isDeleted != 1
        ).length;
      }

      // console.log('Length: ', lengthAnswerCorrect, lengthChooseAnswer, valChoosedHaveValue, self.questionsData, self.isListQuestion)
      if (
        lengthAnswerCorrect > lengthChooseAnswer &&
        !self.questionsData &&
        !self.isListQuestion
      ) {
        statusAnswer = false;
        self.isQuestionMissingAnswer = true;
        self.setActionCheckQuestion(false);
        // if(typeQuestion !== types.TYPE_RADIO && typeQuestion !== types.TYPE_CHECKBOX && typeQuestion !== types.TYPE_X_MARK && typeQuestion !== types.TYPE_CIRCLE_ANSWER) {
        self.textErr = "Bạn hãy điền đầy đủ các câu trả lời!";
        // }
        self.$emit("answerMissing", self.textErr);
        this.$emit("setCorrectAnswer", false);
      } else {
        this.$emit("setCorrectAnswer", true);
        // Reset content fill data for fill blank type
        // self.dataSource.type === types.TYPE_FILL_BLANK &&
        resetContentQuestionFillSelect();

        let answerParent = [];
        // console.log('TTYPE TYOPE: ', typeQuestion)
        if (
          typeQuestion === types.TYPE_SELECT ||
          typeQuestion === types.TYPE_FILL_BLANK
        ) {
          dataQuestion.answers.map((ans) => {
            !ans.position && answerParent.push(ans);
          });
        }

        // Set arr result correct display
        !self.isListQuestion &&
          self.getResultCorrect(dataQuestion, answerParent);

        for (let i = 0; i < lengthChooseAnswer; i++) {
          let positionAnswer;
          let parentSelect = "";

          const positionValChoose = valChoosedHaveValue[i].position;
          let answerCurr =
            typeQuestion === types.TYPE_SELECT ||
            typeQuestion === types.TYPE_FILL_BLANK
              ? answerParent[positionValChoose]
              : dataQuestion.answers[positionValChoose];

          // set position for all answer child (only type == blank or select)
          if (
            typeQuestion === types.TYPE_FILL_BLANK ||
            typeQuestion === types.TYPE_SELECT
          ) {
            parentSelect = valChoosedHaveValue[i].parent;
          }

          // Set position answer
          if (typeQuestion === types.TYPE_FILL_BLANK) {
            // console.log('Set position: ', valChoosedHaveValue, i, valChoosedHaveValue[i].parent)
            let answerWithPosition = dataQuestion.answers.filter(
              (ans) => ans.position === valChoosedHaveValue[i].parent
            );
            let answerWithPositionLength = answerWithPosition.length;

            // console.log('check position for question: ', answerWithPositionLength, answerWithPosition, valChoosedHaveValue, i)
            if (answerWithPositionLength > 1) {
              positionAnswer = dataQuestion.answers.findIndex(
                (ans) =>
                  ans.answerId ===
                  answerWithPosition[answerWithPositionLength - 1].answerId
              );
            } else {
              positionAnswer = dataQuestion.answers.findIndex(
                (ans) => ans.position === valChoosedHaveValue[i].parent
              );
            }

            // console.log('After check position: ', positionAnswer)

            // let answerIndexById = dataQuestion.answers.findIndex()
            // positionAnswer = dataQuestion.answers.findIndex(ans => ans.answerId === answerWithPosition[answerWithPositionLength -1].answerId);
          } else if (typeQuestion === types.TYPE_SELECT) {
            // console.log(i, valChoosedHaveValue[i]);
            positionAnswer = dataQuestion.answers.findIndex(
              (ans) => ans.answerId === parseInt(valChoosedHaveValue[i].value)
            );
          } else {
            positionAnswer = valChoosedHaveValue[i].position;
          }
          let valueAnswer = valChoosedHaveValue[i].value;
          // Check result compare correct
          // compareAnswer(dataQuestion, typeQuestion, positionAnswer, answer, checkParent = '')
          // console.log('answer position: ', positionAnswer);

          if (
            !self.compareAnswer(
              dataQuestion,
              typeQuestion,
              positionAnswer,
              valueAnswer,
              parentSelect
            )
          ) {
            statusAnswer = false;
            // console.log('Check answer fail: ', positionAnswer, i);
            if (
              dataQuestion.answers[positionAnswer] &&
              typeQuestion !== types.TYPE_MATH_COL
            ) {
              // console.log('Check answer: ', positionAnswer);
              dataQuestion.answers[positionAnswer]["err"] = true;
              // IsError support for save server
              dataQuestion.answers[positionAnswer]["isError"] = true;
            }
            // Set validate false for item in select box
            if (
              typeQuestion === types.TYPE_SELECT ||
              typeQuestion === types.TYPE_FILL_BLANK
            ) {
              if (!answerCurr["validate"]) {
                answerCurr["validate"] = [];
                answerCurr["validateVal"] = [];
              }

              // console.log('Set validate FALSE: ', valChoosedHaveValue[i], valChoosedHaveValue[i].select_index);
              // answerCurr.validate[valChoosedHaveValue[i].select_index] = false;
              // answerCurr.validateVal[valChoosedHaveValue[i].select_index] = valChoosedHaveValue[i].value;

              // console.log('HAHA: ', answerCurr.validateVal, )

              answerCurr.validate[
                valChoosedHaveValue[i].position_display
              ] = false;
              answerCurr.validateVal[valChoosedHaveValue[i].position_display] =
                valChoosedHaveValue[i].value;
            }
            if (typeQuestion === types.TYPE_MATH_COL && !self.isListQuestion) {
              // let errVal = [...self.arrMathColLeft];
              // errVal[i]['err'] = true;
              // errVal[i]['err'] = true;
              // self.arrMathColLeft = [...errVal];

              self.arrMathColLeft[positionAnswer / 2]["err"] = true;
              // IsError support for save server
              self.arrMathColLeft[positionAnswer / 2]["isError"] = true;
              // let indexAnsColRight = self.arrMathColRight.findIndex(ans => ans.code === self.arrMathColLeft[positionAnswer/2].answerContent)
              // console.log('check question 1', indexAnsColRight, self.arrMathColLeft[positionAnswer/2], self.arrMathColLeft[positionAnswer/2]['answerContent'])
              // if (indexAnsColRight > -1) {
              // 	self.arrMathColRight[indexAnsColRight]['err'] = true;
              // 	self.arrMathColRight[indexAnsColRight]['isError'] = true;
              // }
            }

            // dataQuestion.answers[positionAnswer]['err'] = true;
          } else if (
            typeQuestion === types.TYPE_SELECT ||
            typeQuestion === types.TYPE_FILL_BLANK
          ) {
            // Set validate true for item in select box
            if (!answerCurr["validate"]) {
              answerCurr["validate"] = [];
              answerCurr["validateVal"] = [];
            }
            // console.log('Set validate: ', valChoosedHaveValue[i], valChoosedHaveValue[i].select_index);
            answerCurr.validate[valChoosedHaveValue[i].position_display] = true;
            answerCurr.validateVal[valChoosedHaveValue[i].position_display] =
              valChoosedHaveValue[i].value;
            // answerCurr.validate[valChoosedHaveValue[i].select_index] = true;
            // answerCurr.validateVal[valChoosedHaveValue[i].select_index] = valChoosedHaveValue[i].value;
          } else if (
            typeQuestion === types.TYPE_MATH_COL &&
            !self.isListQuestion
          ) {
            // let errVal = [...self.arrMathColLeft];
            // errVal[i]['err'] = false;
            // self.arrMathColLeft = [...errVal];
            self.arrMathColLeft[positionAnswer / 2]["err"] = false;
            // IsError support for save server
            self.arrMathColLeft[positionAnswer / 2]["isError"] = false;
            // let indexAnsColRight = self.arrMathColRight.findIndex(ans => ans.code === self.arrMathColLeft[positionAnswer/2].answerContent)
            // console.log('check question 2', indexAnsColRight)
            // if (indexAnsColRight > -1) {
            // 	self.arrMathColRight[indexAnsColRight]['err'] = false;
            // 	self.arrMathColRight[indexAnsColRight]['isError'] = false;
            // }
          } else if (
            [
              types.TYPE_CHECKBOX,
              types.TYPE_CIRCLE_ANSWER,
              types.TYPE_X_MARK,
            ].includes(typeQuestion)
          ) {
            let lengthAnswerCorrect = dataQuestion.answers.filter(
              (ans) => ans.correct
            ).length;
            if (lengthAnswerCorrect > lengthChooseAnswer) {
              statusAnswer = false;
            }
            dataQuestion.answers[positionAnswer]["success"] = true;
          } else {
            // console.log(dataQuestion.answers[positionAnswer]);
            dataQuestion.answers[positionAnswer]["success"] = true;
          }

          // console.log('ancorres', answerCurr)
          this.validateQuestion({
            type: typeQuestion,
            data: this.checkFillType,
          });

          // this.setQuestion({...dataQuestion});
          // return dataQuestion;
          if (positionAnswer > -1) {
            dataQuestion.answers[positionAnswer]["answerContent"] = valueAnswer;
          }
        }
        dataQuestion["statusWorked"] = "worked";

        // console.log('Corect status answer IN: ', statusAnswer);
        self.correctStatus = statusAnswer ? "success" : "error";
        console.log(self.arrMathColRight);
        // Set result for type match col right
        self.arrMathColRight.map((col) => {
          let indexColMatch = self.arrMathColLeft.findIndex(
            (left) => left.answerContent === col.code
          );
          col["isError"] = self.arrMathColLeft[indexColMatch]
            ? self.arrMathColLeft[indexColMatch].isError
            : false;
          col["err"] = self.arrMathColLeft[indexColMatch]
            ? self.arrMathColLeft[indexColMatch].err
            : false;
        });
        // console.log('CHECK QUESTION: ', self.questionsData)

        // console.log('AAAAAA', dataQuestion);
        // typeQuestion !== types.TYPE_GROUP && self.saveQuestionWorked(dataQuestion);
        // if(self.questionsData && self.questionsData.type === types.TYPE_GROUP) {
        // console.log('Data question: ', dataQuestion)
        return dataQuestion;
        // }
      }

      // console.log('Corect status answer: ', statusAnswer);
      // dataQuestion['answerStatus'] = statusAnswer ? 'success' : 'error';
      self.correctStatus = statusAnswer ? "success" : "error";
      // console.log('Check done: ', this.valCorrect)
    },
    // Check parent params is check position of answer
    compareAnswer(
      dataQuestion,
      typeQuestion,
      positionAnswer,
      answer,
      checkParent = ""
    ) {
      let self = this;
      // console.log('Compare: ', positionAnswer, dataQuestion, typeQuestion, answer)
      let answerCurr = dataQuestion.answers[positionAnswer];
      // console.log('Compare 1: ', positionAnswer, answerCurr)

      if (typeQuestion === types.TYPE_FILL_BLANK) {
        if (answerCurr && answerCurr.content) {
          // let answerCurrent = self.stripHtml(answerCurr.content);
          let answerCurrent = stripHtml(answerCurr.content);
          return answerCurr && answerCurr.content && answerCurr.position
            ? answerCurrent.trim().toLowerCase() ===
                answer.trim().toLowerCase() &&
                answerCurr.position === checkParent
            : false;
        }
        return false;
      } else if (typeQuestion === types.TYPE_SELECT) {
        return answerCurr && answerCurr.correct && answerCurr.position
          ? parseInt(answerCurr.answerId) === parseInt(answer) &&
              answerCurr.position === checkParent
          : false;
      } else if (typeQuestion === types.TYPE_TRUE_FALSE_NO) {
        if (answerCurr.correct) {
          self.arrResultCorrect[positionAnswer] = {
            code: answerCurr.code || parseInt(positionAnswer) + 1,
            value: answerCurr.correct,
          };
        }
        return answerCurr && answerCurr.correct
          ? answer.toLowerCase().includes(answerCurr.correct.toLowerCase())
          : false;
      } else {
        if (
          ((typeQuestion === types.TYPE_FILL_INPUT_IMG &&
            !self.questionsData) ||
            typeQuestion === types.TYPE_MATH_COL) &&
          answerCurr.correct
        ) {
          self.arrResultCorrect[positionAnswer] = {
            code: answerCurr.code || parseInt(positionAnswer) + 1,
            value: answerCurr.correct,
          };
        }
        console.log(answerCurr && answerCurr.correct);
        return answerCurr && answerCurr.correct
          ? answerCurr.correct.toLowerCase() === answer.toLowerCase()
          : false;
      }
    },

    getResultCorrect(dataQuestion, answerParent = []) {
      let self = this;
      let answerList = dataQuestion.answers;
      let typeQuestion = dataQuestion.type;
      // console.log('Result get: ', answerList)
      if (
        typeQuestion === types.TYPE_SELECT ||
        typeQuestion === types.TYPE_FILL_BLANK
      ) {
        answerList.map((ans) => {
          if (ans.position) {
            let positionItem = ans.position.split("_");
            // console.log('Get result content: ', positionItem);
            /**
             * positionItem[0]: position answer parent
             * positionItem[1]: position correct in answer
             **/

            let codeAnswer =
              answerParent[positionItem[0]] &&
              answerParent[positionItem[0]].code
                ? answerParent[positionItem[0]].code
                : parseInt(positionItem[0]) + 1;
            if (
              (ans.correct && typeQuestion === types.TYPE_SELECT) ||
              (ans.content && typeQuestion === types.TYPE_FILL_BLANK)
            ) {
              let valAnswerCurr =
                (typeQuestion === types.TYPE_FILL_BLANK
                  ? ans.content
                  : ans.correct) || "";

              if (
                self.questionsData &&
                self.questionsData.type === types.TYPE_GROUP
              ) {
                let indexQuestionCurr = self.arrResultCorrect.findIndex(
                  (que) => que.questionId === dataQuestion.questionId
                );

                if (indexQuestionCurr > -1) {
                  if (
                    !self.arrResultCorrect[indexQuestionCurr].correct[
                      positionItem[0]
                    ]
                  ) {
                    self.arrResultCorrect[indexQuestionCurr].correct[
                      positionItem[0]
                    ] = { code: codeAnswer, value: [] };
                  }
                  self.arrResultCorrect[indexQuestionCurr].correct[
                    positionItem[0]
                  ].value[positionItem[1]] = valAnswerCurr;
                } else {
                  let newDataCorrect = {
                    questionId: dataQuestion.questionId,
                    type: dataQuestion.type,
                    title: dataQuestion.title,
                    correct: [{ code: codeAnswer, value: [] }],
                  };
                  // console.log('New data: ', newDataCorrect, positionItem)
                  self.arrResultCorrect.push(newDataCorrect);
                  self.arrResultCorrect[0].correct[positionItem[0]].value[
                    positionItem[1]
                  ] = valAnswerCurr;
                  // console.log('Result child: ', self.arrResultCorrect, typeQuestion)
                }
              } else {
                if (!self.arrResultCorrect[positionItem[0]]) {
                  self.arrResultCorrect[positionItem[0]] = {
                    code: codeAnswer,
                    value: [],
                  };
                }

                // console.log('Set ar result: ', self.arrResultCorrect, positionItem);
                self.arrResultCorrect[positionItem[0]].value[positionItem[1]] =
                  valAnswerCurr;
              }
            }
          }
        });
      } else {
        answerList.map((ans, index) => {
          if (ans.content && ans.correct) {
            // console.log('hyt', dataQuestion.type)
            let valueResult = {
              code: ans.code || index + 1,
              value: ans.correct,
              type: typeQuestion,
            };

            if (
              self.questionsData &&
              self.questionsData.type === types.TYPE_GROUP
            ) {
              let indexQuestionCurr = self.arrResultCorrect.findIndex(
                (que) => que.questionId === dataQuestion.questionId
              );
              // console.log('Get value for group question: ', indexQuestionCurr, dataQuestion.questionId)
              if (indexQuestionCurr > -1) {
                self.arrResultCorrect[indexQuestionCurr].correct.push(
                  valueResult
                );
              } else {
                self.arrResultCorrect.push({
                  questionId: dataQuestion.questionId,
                  title: dataQuestion.title,
                  correct: [valueResult],
                });
              }
              // console.log('Result: ', self.arrResultCorrect)
            } else if (
              dataQuestion &&
              dataQuestion.type !== types.TYPE_MATH_COL
            ) {
              self.arrResultCorrect.push(valueResult);
            }
          }
        });
      }
      // console.log('Result: ', self.arrResultCorrect)
    },

    saveQuestionWorked(data) {
      let questionLocal = JSON.parse(
        localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED)
      );
      if (
        questionLocal &&
        questionLocal !== undefined &&
        questionLocal.length > 0
      ) {
        let indexQuestionSave = questionLocal.findIndex(
          (ques) => ques.questionId === data.questionId
        );
        // console.log('Save question: ', indexQuestionSave, questionLocal, data)
        if (indexQuestionSave > -1) {
          questionLocal[indexQuestionSave] = data;
        } else {
          questionLocal.push(data);
        }
        this.saveLocalQuestion(questionLocal);
      } else {
        this.saveLocalQuestion([data]);
      }
    },

    saveLocalQuestion(data) {
      this.setActionCheckQuestion(true);
      localStorage.setItem(LOCAL_SAVE_QUESTIONS_WORKED, JSON.stringify(data));
      this.setActionCheckQuestion(false);
    },

    handleChangeTxtAnswer(val) {
      this.valueHTMLAnswerTypEessay = val.html;
    },

    resetValKeyboard() {
      this.valVituralKeyboard && this.setVituralKeyVal({});
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-back-ex {
  position: absolute;
  left: -19px;
  top: 5px;
  font-size: 24px;
}
.question-item {
  &__head {
    margin-bottom: 5px;

    .item table {
      margin: 8px auto;
    }
  }
}

.item {
  &:hover {
    color: inherit !important;
  }

  &__question {
    font-weight: 500;
    margin-bottom: 15px;
    padding-bottom: 5px;
    border-bottom: 1px solid #f1f1f1;
    color: #000;
    font-size: 16px;

    b {
      margin-right: 8px;
    }
  }
  &__title {
    width: 60px;
    text-align: center;
    padding: 7px;
    background: #e1efff;
    border-radius: 5px;
  }
}

.answer-result {
  border: 1px solid #38c172;
  padding: 10px;
  margin-top: 5px;

  ul {
    li {
      list-style: none;
      margin-bottom: 8px;

      > b {
        font-size: 15px;
      }

      > span {
        margin-left: 25px;
      }
    }
  }

  &--answer_t_f_no,
  &--math_col {
    ul {
      li {
        width: 25%;
        display: inline-block;

        > span {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
